export interface SelectTagFormat {
  label: string
  value: string
  [key: string]: any // To support additional properties
}

export function mapDataToSelectData(
  array: any[],
  valueField: string,
  labelField: string,
  ...additionalFields: string[]
): SelectTagFormat[] | [] {
  if (array) {
    return array.map((item) => {
      const selectItem: SelectTagFormat = {
        label: item[labelField],
        value: String(item[valueField]), // Ensure value is a string
      }

      // Add additional properties if specified
      additionalFields.forEach((field) => {
        if (item[field] !== undefined)
          selectItem[field] = item[field]
      })

      return selectItem
    })
  }
  else { return [] }
}
